
import { ORDER_PROCESSING_REQUEST } from "../../constantTypes/checkout4/orderContstantTypes";


export const OrderReducer=(state=[],action)=> {
    let payload=action.payload|| undefined;
    if(payload===undefined || payload===null || payload===0){
        payload={orderModel:{}};
    }
    switch (action.type) {
        case ORDER_PROCESSING_REQUEST:
       
            return {   ...state,orderModel:payload}
           
               
              
        default: return state;
            
    }
}